module.exports = __webpack_public_path__ + "static/media/pt_BR.0ae04685.svg";